export default "__VITE_PUBLIC_ASSET__b22e5c5f__"